
export default function Reports() {
    return (
        <>
            <div class="section-header justify-content-between align-items-center mb-3">
                <h4 class="mb-1 fw-bold">Reports</h4>
                <small class="text-muted">
                    Overview of your trading performance
                </small>
            </div>
            <main class="">
                Coming Soon...
            </main>
        </>
    )
}